import React from 'react';
import styled, { useTheme } from 'styled-components';

import { Button, Modal } from '../../shared/Components';
import { FlexContainer, Text } from '../../shared/Typhography';
import { strings } from '../../strings';
import { RemoveImage } from '../../assets/Modal';
import { useGlobalModalContext } from '../../context/GlobalModal';

const Background = styled.img`
  background-color: ${({ theme }) => theme.colors.lightPurple};
  width: 100%;
  height: 60%;
  text-align: center;
  padding: 20px;
  box-sizing: border-box;
`;

const DeleteModal = () => {
  const { hideModal, store } = useGlobalModalContext();
  const { modalProps } = store || {};
  const { title, text, deleteButtonComponent } = modalProps || {};
  const { colors } = useTheme();

  const closeModal = () => {
    hideModal();
  };

  return (
    <Modal padding="0" height={440} width={460} closeModal={closeModal} onRequestClose={closeModal}>
      <Background src={RemoveImage} alt="Remove" />
      <FlexContainer flexDirection="column" alignItems="center" gap="1.2rem" height="200px">
        <Text size={2.2} color={colors.black} weight="bold">
          {title}
        </Text>
        <Text size={1.2} color={colors.gray} weight="bold">
          {text}
        </Text>
        <FlexContainer gap="1rem" justifyContent="center">
          <Button variant="link" onClick={hideModal}>
            {strings.cancel}
          </Button>
          {deleteButtonComponent}
        </FlexContainer>
      </FlexContainer>
    </Modal>
  );
};

export default DeleteModal;
